<template>
  <!-- #region Menu -->
  <div v-if="getGroupList.length > 1">
    <v-menu class="px-2" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn class="mt-3 px-2 whiteBg" depressed medium v-on="on">
          <span>Group By :</span>
          <span class="pl-2">{{ getSelectedGroupBy }}</span>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(item, index) in getGroupList" :key="index">
          <v-list-tile-title @click="ChangeGroupBy(item)">
            {{ item }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "GroupBy",
  data: () => ({}),
  computed: {
    getGroupList() {
      if (this.getUserDetails.group) {
        var index = this.getGroupByList.indexOf(this.getUserDetails.group);
        if (index >= 0) {
          return this.getGroupByList.slice(index).reverse();
        }
      }
      return [];
    },
    ...mapGetters([
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
      "getSelectedGroupBy",
      "getGroupByList",
      "getUserDetails",
    ]),
  },
  mounted() {
    ///Checking Local storage for previously Saved group type
    var groupByType = localStorage.getItem("groupByType");
    if (groupByType && this.getGroupList.includes(groupByType)) {
      this.ChangeGroupBy(groupByType);
    } else {
      // First Time

      var index = this.getGroupByList.indexOf(this.getUserDetails.group);
      groupByType = index <= 2 ? "Team" : "Branch";
      this.$store.commit("setSelectedGroupBy", groupByType);
    }
  },
  methods: {
    ChangeGroupBy(groupItem) {
      if (groupItem == "Team" && this.getSelectedTeam.Team == 0) {
        this.$router.app.$emit("openAreaTeamBranchPopup", "team");
      } else if (groupItem == "Branch" && this.getSelectedBranch.Office == 0) {
        this.$router.app.$emit("openAreaTeamBranchPopup", "branch");
      } else {
        this.$store.commit("setSelectedGroupBy", groupItem);
        localStorage.setItem("groupByType", groupItem);
      }
    },
  },
};
</script>
